import { TeamPlayer } from "@/types/player"
import { isUndefined } from "lodash"

export const useGetInfoIsErr = (newPlayer: TeamPlayer | undefined) => {
  if (!newPlayer) {
    return true
  }
  const { nickname, uniformNumber, position, height, weight, foot } = newPlayer
  const isEmpty =
    !nickname ||
    (typeof uniformNumber === "string" && !uniformNumber) ||
    !position ||
    isUndefined(height) ||
    isUndefined(weight) ||
    !foot
  const isError =
    nickname.length > 35 || uniformNumber > 100 || uniformNumber < 0 || height < 0 || weight < 0

  return isEmpty || isError
}
